<div class="upload-dialog" data-testid="upload-dialog">
  <div class="upload-dialog__header" data-testid="dialog-header">
    <h3
      class="upload-dialog__title"
      data-testid="upload-dialog__title"
      #titleRef
      tabindex="0"
    >
      Upload Documents
    </h3>
    <button
      mat-icon-button
      wcg-button
      (click)="handleCancel()"
      data-testid="cancel-button"
    >
      <mat-icon data-testid="close-icon">close</mat-icon>
    </button>
  </div>
  @if (bannerClose) {
    <div class="banner_close_style">
      <wcg-banner
        [bodyCopy]="bannerText()"
        [bannerType]="bannerType.ALERT"
        [closeButton]="true"
        ($handleBannerClose)="handleBannerClose()"
      ></wcg-banner>
    </div>
  }
  <mat-dialog-content
    wcg-dialog
    class="upload-dialog__content"
    data-testid="upload-dialog__content"
    style="overflow: auto !important"
  >
    <div class="upload-dialog__content-row" data-testid="content-row-upload">
      <wcg-upload-file
        #uploadFileComponent
        class="upload-dialog__upload-file"
        (fileUpload)="fileUpload($event)"
        data-testid="upload-dialog__upload-file"
        [multiSelect]="true"
      />
    </div>
    <div
      class="upload-dialog__content-row"
      data-testid="upload-dialog__content-row"
    >
      <mat-accordion class="upload-dialog__accordion" data-testid="accordion">
        <mat-expansion-panel
          wcg-expansion-panel
          class="upload-dialog__panel"
          data-testid="expansion-panel"
        >
          <mat-expansion-panel-header
            class="upload-dialog__panel-header"
            data-testid="panel-header"
          >
            <mat-panel-description
              class="upload-dialog__panel-description"
              data-testid="panel-description"
            >
              View all restrictions for uploading documents
            </mat-panel-description>
          </mat-expansion-panel-header>
          <ul class="upload-dialog__list" data-testid="restrictions-list">
            <li class="upload-dialog__list-item" data-testid="list-item-size">
              File size limit 1 GB
            </li>
            <li
              class="upload-dialog__list-item"
              data-testid="list-item-name-length"
            >
              File name length limit 255 characters
            </li>
            <li
              class="upload-dialog__list-item"
              data-testid="list-item-unique-name"
            >
              File name must be unique
            </li>
            <li
              class="upload-dialog__list-item"
              data-testid="list-item-no-encrypt"
            >
              File cannot be encrypted or be password protected
            </li>
            <li
              class="upload-dialog__list-item"
              data-testid="list-item-valid-types"
            >
              Valid file types: {{ allowedFileTypes }}
            </li>
            <li
              class="upload-dialog__list-item"
              data-testid="list-item-no-encrypt"
            >
              File cannot contain any of the following characters:
              <span class="upload-dialog__list-item-characters">
                {{ forbiddenCharacters }}
              </span>
            </li>
          </ul>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    @if (uploadedFiles.length) {
      <div>
        <div class="grid grid-cols-3 gap-4 border-b-2">
          <div class="pb-2">File Name</div>
          <div class="pb-2">Document Type</div>
          <div class="pb-2">Document Name</div>
        </div>

        @for (file of uploadedFiles; track file; let index = $index) {
          <div data-testid="uploaded-file" [formGroup]="files.controls[index]">
            <wcg-upload-file-row
              data-testid="upload-file-row"
              [documentTypes]="documentTypes()"
              [requiredTypesForSubmission]="requiredTypesForSubmission"
              [requiredDocument]="requiredDocument"
              [isLast]="index === uploadedFiles.length - 1"
              [isRequired]="isDocumentTypeRequired(file)"
              (handleDeleteFile)="onDeleteFile(index)"
            />
          </div>
        }
      </div>
    }
  </mat-dialog-content>
  <div
    class="upload-dialog__sticky-container"
    [class.scrolling]="files!.length > 4"
    data-testid="sticky-container-footer"
  >
    <div class="upload-dialog__btn-container" data-testid="button-container">
      <div class="upload-dialog__important-info">
        {{ !multiSelect ? "Only one file can be uploaded at a time*" : "" }}
      </div>
      <div
        tertiary
        class="upload-dialog__btn-container-item"
        data-testid="cancel-button-container"
      >
        <wcg-button
          color="tertiary"
          (click)="handleCancel()"
          data-testid="cancel-button-footer"
          >Cancel</wcg-button
        >
      </div>

      <div
        primary
        class="upload-dialog__btn-container-item"
        data-testid="confirm-button-container"
      >
        <wcg-button
          color="primary"
          (click)="handleConfirm()"
          data-testid="confirm-button"
          [isDisabled]="!uploadedFiles?.length"
          >Upload</wcg-button
        >
      </div>
    </div>
  </div>
</div>
